import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type IncentiveOfferAlreadyParticipatedBannerProps = {
  onViewOperation?: () => void;
};

const IncentiveOfferAlreadyParticipatedBanner: FC<
  IncentiveOfferAlreadyParticipatedBannerProps
> = ({ onViewOperation }) => {
  const { t } = useTranslate();

  return (
    <div className="alert alert-info alert-icon mb-4">
      <em className="icon ni ni-info" />
      <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
        <div className="pr-3">
          <h6 className="alert-heading">{t('IncentiveOfferAlreadyParticipated')}</h6>
          <p className="mb-0">{t('IncentiveOfferAlreadyParticipatedDescription')}</p>
        </div>
        {onViewOperation && (
          <button
            type="button"
            className="btn btn-outline-primary mt-2 mt-md-0"
            onClick={onViewOperation}
            data-testid="view-my-operation-button"
          >
            {t('ViewMyOperation')}
          </button>
        )}
      </div>
    </div>
  );
};

export default IncentiveOfferAlreadyParticipatedBanner;
